import API from '../../services/API'
import {
    CONTACTS_GETTER,
    CONTACTS_GETTER_GUESTLIST,
    CONTACTS_MUTATION_SINGLE_ENTRY,
    CONTACTS_MUTATION_ENTIRE_CONTACTS,
    CONTACTS_MUTATION_SINGLE_CONTACT,
    CONTACTS_MUTATION_DELETE_CONTACT,
    CONTACTS_MUTATION_DELETE_ALL_CONTACTS,
    CONTACTS_MUTATION_CREATE_CONTACT,
    CONTACTS_ACTION_GET_CONTACTS,
    CONTACTS_ACTION_DELETE_CONTACT,
    CONTACTS_ACTION_UPDATE_CONTACT,
    CONTACTS_ACTION_DELETE_ALL_CONTACTS,
    CONTACTS_ACTION_CREATE_CONTACT
} from './contacts-types'

import Vue from 'vue'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        contacts: []
    },

    getters: {
        [CONTACTS_GETTER]: state => state.contacts,
        [CONTACTS_GETTER_GUESTLIST]: state => {
            return state.contacts.filter(obj => {
                return obj.onGuestlist
            })
        }
    },

    mutations: {
        [CONTACTS_MUTATION_SINGLE_ENTRY] (state, payload) {
            let key = Object.keys(payload)[0]
            Vue.set(state.contacts, key, payload[key])
        },
        [CONTACTS_MUTATION_ENTIRE_CONTACTS] (state, payload) { state.contacts = payload },
        [CONTACTS_MUTATION_SINGLE_CONTACT] (state, payload) {
            for (let i = 0; i < state.contacts.length; i++) {
                if (state.contacts[i].id === payload.id) {
                    state.contacts.splice(i, 1, payload)
                }
            }
        },
        [CONTACTS_MUTATION_DELETE_CONTACT] (state, payload) {
            for (let i = 0; i < state.contacts.length; i++) {
                if (state.contacts[i].id === payload) {
                    state.contacts.splice(i, 1)
                }
            }
        },
        [CONTACTS_MUTATION_CREATE_CONTACT] (state, payload) {
            state.contacts.push(payload[0])
        },
        [CONTACTS_MUTATION_DELETE_ALL_CONTACTS] (state, payload) {
            state.contacts = []
        }
    },

    actions: {
        [CONTACTS_ACTION_GET_CONTACTS] ({ commit }) {
            return new Promise(
                function (resolve, reject) {
                    API.loadContacts()
                        .then((contactsData) => {
                            commit(CONTACTS_MUTATION_ENTIRE_CONTACTS, contactsData.contacts)
                            resolve()
                        })
                        .catch((error) => {
                            console.log('' + error.message)
                            reject(error)
                        })
                })
        },
        [CONTACTS_ACTION_DELETE_CONTACT] ({commit, state}, payload) {
            API.deleteContact(payload)
                .then(() => {
                    OAlert.showSuccess('', i18n.t('feedback.contactSucDelete'))
                    commit(CONTACTS_MUTATION_DELETE_CONTACT, payload)
                })
                .catch((error) => console.log(error.message))
        },
        [CONTACTS_ACTION_CREATE_CONTACT] ({commit, state}, payload) {
            API.createContact(payload)
                .then((contactData) => {
                    OAlert.showSuccess('', i18n.t('feedback.contactSucAdd'))
                    commit(CONTACTS_MUTATION_CREATE_CONTACT, contactData)
                })
                .catch((error) => console.log(error.message))
        },
        [CONTACTS_ACTION_UPDATE_CONTACT] ({commit, state}, payload) {
            API.updateContact(payload)
                .then((contactData) => {
                    OAlert.showSuccess('', i18n.t('feedback.contactGuestlistSucAdd'))
                    commit(CONTACTS_MUTATION_SINGLE_CONTACT, contactData)
                })
                .catch((error) => console.log(error.message))
        },
        [CONTACTS_ACTION_DELETE_ALL_CONTACTS] ({commit, state}) {
            API.deleteAllContacts()
                .then(() => {
                    OAlert.showSuccess('', i18n.t('feedback.allContactsSucDelete'))
                    commit(CONTACTS_MUTATION_DELETE_ALL_CONTACTS)
                })
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts.js